import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=2a021f88&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=2a021f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a021f88",
  null
  
)

export default component.exports